import { render, staticRenderFns } from "./ImportarEmpleados.vue?vue&type=template&id=7966dc20&"
import script from "./ImportarEmpleados.vue?vue&type=script&lang=js&"
export * from "./ImportarEmpleados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports